import { Collection } from 'modules/core/lib/mobx-rest'

import Log from 'modules/documents/store/models/Log'

class Logs extends Collection<Log> {
  get cacheKey(): string {
    return 'logs'
  }

  model() {
    return Log
  }
}

export default Logs
